'use strict'; // http://262.ecma-international.org/5.1/#sec-9.1

module.exports = require('es-to-primitive/es5');